import { render, staticRenderFns } from "./ChallengeEmail.vue?vue&type=template&id=71344121"
import script from "./ChallengeEmail.vue?vue&type=script&lang=js"
export * from "./ChallengeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChallengeEmail.vue?vue&type=style&index=0&id=71344121&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports